import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withProps, compose } from 'recompose'
import { throttle } from 'lodash'
import {
  createMarketInterest,
  deleteMarketInterest,
} from '../../../../actions/buyerInfo'

const throttledClick = throttle(fn => fn(), 1000, { trailing: false })

const FavoriteContainer = compose(
  connect(
    (state, { zipcode }) => {
      const marketInterest = state.buyerInfo.marketInterests.find(
        mi => mi.zipcode === zipcode
      )

      return {
        isFavorite: Boolean(marketInterest),
        marketInterest,
      }
    },
    dispatch => ({
      removeFavorite: id => dispatch(deleteMarketInterest(id)),
      addFavorite: zipcode => dispatch(createMarketInterest(zipcode)),
    })
  ),
  withProps(
    ({ isFavorite, zipcode, marketInterest, addFavorite, removeFavorite }) => ({
      onClick: e => {
        e.stopPropagation()
        throttledClick(() => {
          if (isFavorite) {
            removeFavorite(marketInterest.id)
          } else {
            addFavorite(zipcode)
          }
        })
      },
    })
  )
)

FavoriteContainer.PropTypes = {
  zipcode: PropTypes.string.isRequired,
}

export default FavoriteContainer
